module.exports = {
      id: "dab13dab58181a94510b0af51667c148gas-yes.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#dab13dab58181a94510b0af51667c148gas-yes.svg",
      toString: function () {
        return this.url;
      }
    }